/* Import components */

import React, {useState} from 'react';
import {Field} from 'formik';
import {DataTable, Form} from '../components';
import {acceptFiles} from '../config';
import {axios} from '../libs';

/* Format date */

function formatDateDMY(date) {
	if (!date) return '';
	const d = new Date(date);
	const day = d.getDate().toString().padStart(2, '0');
	const month = (d.getMonth() + 1).toString().padStart(2, '0');
	const year = d.getFullYear();
	return `${day}.${month}.${year}`;
}

/* Export documents */

export const Documents = React.memo(() => {
	const [refetch, setrefetch]         = useState(false);
	const [isMultipart, setIsMultipart] = useState(false);
	const initialValues                 = {name: '', document: null,};
	
	/* Modal handlers */
	
	const [isModalOpen, setIsModalOpen] = useState(false);
	const openModal  = () => { setIsModalOpen(true); };
	const closeModal = () => { setIsModalOpen(false); };
	const onSuccess  = ({chatbot}) => { setrefetch(true); };
	
	/* Table actions */
	
	const onDelete = ({_id, name}) => {
		setrefetch(false);
		window.nConfirm({
			icon: 'fa-question-circle',
			title: 'Delete document?',
			text: `<span>${name}</span>`,
			onYes: () => {deleteDocument(_id)},
			onNo:  () => {},
		});
	};
	
	const deleteDocument = async (id) => {
		const deleteId = id;
		await axios.post(`/user/deleteDocument`, {deleteId});
		setrefetch(true);
	};

	/* Table columns */
	
	const tableColumns = [
		{
			dataField: 'name',
			text: 'Name',
			classes: 'cell-name',
			headerClasses: 'cell-name',
		},
		/*
		{
			dataField: 'createdAt',
			text: 'Created',
			classes: 'cell-created',
			headerClasses: 'cell-created',
			formatter: d => formatDateDMY(d),
		},
		*/
	];
	
	/* Render HTML */
	
	return (
	<>
		<div id="documents" className="row table_v2 documents">
			<div className="col p-0">
				<div className="x_panel chatbot-builder">
					<div className="header-menu d-flex justify-content-between align-items-center">
						<div className="header-title d-flex align-items-center">
							<h1>Documents</h1>
						</div>
						<div className="header-actions d-flex align-items-center">
							<div className="action action-addnew">
								<button className="button button-blue" onClick={openModal}>
									+ Add New
								</button>
							</div>
						</div>
					</div>
					<div className="x_content">
						<div className="page-container d-flex flex-column">
							<div className="page-content">
								<DataTable
								dataKey       = "documents"
								tableHeading  = "Documents"
								url           = "/user/documents"
								navigateTo    = "https://docs.google.com/document/d"
								columns       = {tableColumns}
								refetch       = {refetch}
								onDelete      = {onDelete}
								defaultSorted = {[{ dataField: 'name', order: 'asc' }]}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Modal */}
			{isModalOpen && (
				<div className="modal document" onClick={closeModal}>
					<div className="modal-content" onClick={e=>e.stopPropagation()}>
						<div className="modal-header">
							<span className="modalclose" onClick={closeModal}>&times;</span>
							<h2>New document</h2>
						</div>
						<div className="modal-form">
							<Form
							enctype       = "multipart/form-data"
							multipart     = {isMultipart}
							url           = {isMultipart ? '/user/documents/upload' : '/user/documents'}
							initialValues = {initialValues}
							onSuccess     = {onSuccess}
							>
								<div className="form-row col-full row-name">
									<Field id="name" placeholder="Document name" name="name" type="text" />
								</div>
								<div className="form-row col-full row-document">
									<Field name="document">
									{({field, form}) => (
										<input
										type      = "file"
										name      = "document"
										accept    = {acceptFiles.toString()}
										onChange  = {(event) => {
											const {
												target: {
													files: [file],
												},
											} = event;
											form.setFieldValue('document', file);
											setIsMultipart(true);
										}}
										/>
									)}
									</Field>
								</div>
								<div className="form-row col-full row-actions">
									<button type="button" className="button button-large" onClick={closeModal}>Cancel</button>
									<button type="submit" className="button button-large button-blue">Create</button>
								</div>
							</Form>
						</div>
					</div>
				</div>
			)}
		</div>
		{
			/*
			<div className="row">
				<div className="col-md-6">
					<div className="x_panel">
						<div className="x_title">
							<h2>New Document</h2>
							<div className="clearfix"></div>
						</div>
						<div className="x_content">
							<br />
							<Form
								enctype="multipart/form-data"
								multipart={isMultipart}
								url={isMultipart ? '/user/documents/upload' : '/user/documents'}
								initialValues={initialValues}
								onSuccess={onSuccess}
							>
								<div className="row mb-3">
									<label htmlFor="name" className="col-3 col-form-label">Document Name</label>
									<div className="col-9">
										<Field id="name" name="name" type="text" className="form-control" />
									</div>
								</div>

								<div className="row mb-3">
									<label htmlFor="document" className="col-3 col-form-label">Select Document</label>
									<div className="col-9">
										<Field name="document">
										{({field, form}) => (
											<input
											onChange={(event) => {
												const {
												target: {
													files: [file],
												},
												} = event;
												form.setFieldValue('document', file);
												setIsMultipart(true);
											}}
											accept={acceptFiles.toString()}
											type="file"
											name="document"
											className="form-control"
											/>
										)}
										</Field>
									</div>
								</div>
								<div className="ln_solid"></div>
								<div className="col-md-9 col-sm-9  offset-md-3">
									<button type="submit" className="btn btn-success">Save</button>
								</div>
							</Form>
						</div>
					</div>
				</div> 
				<div className="col-md-6">
					<div className="x_panel">
						<div className="x_title">
						<h2>Documents</h2>
						<div className="clearfix"></div>
						</div>
						<div className="x_content"></div>
						<DataTable
						onDelete={() => {}}
						refetch={refetch}
						navigateTo="https://docs.google.com/document/d"
						url="/user/documents"
						dataKey="documents"
						tableHeading="Documents"
						columns={tableColumns}
						/>
					</div>
				</div>
			</div>
			*/
		}
	</>
	);
});
